<template>
    <form class="form-register" method="post" :action="regionRelativeUrl('/users/login/')" @submit="authenticate">

        <div class="form-group">
            <live-country-component :post-fix-path="`/users/login/`"></live-country-component>
        </div>

        <div class="form-group">

            <span class="error-input-container"
                  v-bind:class="{'has-error': ($v.auth.email.$error && formSubmitted)
                  && (!$v.auth.email.required || !$v.auth.email.email)}">
                <input type="text" id="inputEmail" class="form-control" :placeholder="translate.login.emailOrPhoneLogin"
                       v-model.trim="$v.auth.email.$model" name="email" autocomplete="off">
            </span>

            <span v-if="$v.auth.email.$error || formSubmitted">

                <error-component v-if="!$v.auth.email.required"
                                 :message="translate.login.emailRequired"></error-component>

            </span>

        </div>

        <div class="form-group">

            <span class="error-input-container"
                  v-bind:class="{'has-error': ($v.auth.password.$error || formSubmitted)
                  && !$v.auth.password.required}">
                <input type="password" id="inputPassword" class="form-control" :placeholder="translate.login.password"
                       v-model.trim="$v.auth.password.$model" name="password">
            </span>

            <span v-if="$v.auth.password.$error || formSubmitted">

                <error-component v-if="!$v.auth.password.required"
                                 :message="translate.login.passwordRequired"></error-component>

            </span>

        </div>

        <div class="two-column-grid">
            <a :href="regionRelativeUrl('/users/forgot-password/')"
               class="teal-text-button d-flex align-items-center">{{ translate.login.forgotPassword }}</a>
            <button-with-loading-component class="btn btn-primary btn-block"
                                           :disabled="$v.$anyDirty && $v.$invalid"
                                           type="submit"
                                           :text="translate.login.login"
                                           :loading="loading"
            ></button-with-loading-component>
        </div>

    </form>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators';
import LiveCountryComponent from "@/components/partials/LiveCountryComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

const data = () => ({
    formError: '',
    formSubmitted: false,
    auth: {
        email: '',
        password: ''
    },
    loading: false,
});

async function authenticate(e) {
    this.loading = true;
    this.formSubmitted = true;
    this.formError = false;

    if (this.$v.$invalid) {
        e.preventDefault();
        this.loading = false;
    } else {
        return true;
    }
}

export default {
    components: {LiveCountryComponent},
    mixins: [validationMixin, regionsUrlMixin],
    data,
    validations: {
        auth: {
            email: {
                required
            },
            password: {
                required,
            },
        }
    },
    methods: {
        authenticate,
    },
    computed: {
        ...mapState([
            'translate'
        ]),
    },
};
</script>
